const { same } = require('../utils');

exports.computeHasHeaderColumnFromTables = tables => same(tables, 'hasHeaderColumn', false);
